import styles from "./HeroCard.module.css";

interface HeroCardProps {
  eyebrow: string;
  title: string;
  description: string;
}

/** The Overview hero panel. A feature-local presentational component. */
export function HeroCard({ eyebrow, title, description }: HeroCardProps) {
  return (
    <section className={styles.card}>
      <div className={styles.copy}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </section>
  );
}
